<template>
  <div>
      <div id="myChart">
        <van-loading v-if="isLoading" />
      </div>
  </div>
</template>

<script>
export default {
  name: 'lineEcharts',
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isLoading: true,
      title: '', // 图表标题
      names: ["抽烟","厨师服","鼠患","厨师帽","打电话"], // 显示的名字
      data: [2,3,5,3,1], // 显示的数据
      res: []
    }
  },

  async created() {
  },
  async mounted() {
    this.drawLine()
  },
  watch: {
    options: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.chart.setOption(newVal);
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    drawLine() {
      // 基于刚刚准备好的 DOM 容器，初始化 EChart 实例
      const myChart = this.$echarts.init(document.getElementById('myChart'))

      const option = {
        // 设置图标距离四周的距离
        grid: {
          top: 50,
          left: 50, // 调整这个属性
          right: 50,
          bottom: 20
        },
        color: ['#5E8DFA', '#44D4FA', '#67F190'],
        tooltip: {},
        xAxis: [{
            type: 'category',
            axisTick: { show: false },
            data: ['24/09', '24/10', '24/11', '24/12', '25/01']
          }
        ],
        yAxis: [{
            type: 'value',
            
          }
        ],
        series: [{
            name: '设备1',
            type: 'bar',
            barGap: 0,
            emphasis: {
              focus: 'series'
            },
            barWidth: 10,
            data: [320, 332, 301, 334, 390]
          },
          {
            name: '设备2',
            type: 'bar',
            emphasis: {
              focus: 'series'
            },
            barWidth: 10,
            // itemStyle: {
            //   color: "#44D4FA"
            // },
            data: [220, 182, 191, 234, 290]
          },
          {
            name: '设备3',
            type: 'bar',
            emphasis: {
              focus: 'series'
            },
            barWidth: 10,
            // itemStyle: {
            //   color: "#67F190"
            // },
            data: [150, 232, 201, 154, 190]
          }
        ]
      }
      myChart.setOption(option)
      this.isLoading = false
    },
    beforeDestroy() {
      if (this.chart) {
        this.chart.dispose();
      }
    }
  }
}
</script>
<style lang="less" scoped>
#myChart {
  width: 100%;
  height: 260px;
  padding: 0px;
  background: #fff;
}
</style>
